module.exports = __webpack_public_path__ + "img/page2-2.0d865212.png";